import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconMinus = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={className}
            fill='none'
            height='15'
            viewBox='0 0 15 15'
            width='15'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M15 6.32422H8.67285H6.27539H0V8.72754H6.27539H8.67285H15V6.32422Z'
                fill={fill}/>
        </svg>

    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconMinus;
